import {
  AnyAction,
  applyMiddleware,
  compose,
  legacy_createStore as createStore
} from 'redux';
import { persistStore } from 'redux-persist';
import thunk, { ThunkDispatch } from 'redux-thunk';
import { createRootReducer } from '../reducers';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(applyMiddleware(thunk));

const rootReducer = createRootReducer();

export const store = createStore(rootReducer, enhancer);
export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the reducer
export type RootState = ReturnType<typeof rootReducer>;

// any type here is used for generic purpose
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AppDispatch = ThunkDispatch<RootState, any, AnyAction>;
